import React from 'react';
import styled from 'styled-components';

import WorkflowEditPage, { WorkflowEditPageProps } from '../WorkflowEditPage';

const StyledContainer = styled.div`
  width: 100%;
  height: 100%;
  overflow-y: auto;
  & > * {
    width: 100%;
    height: 100%;
  }
`;

const WorkflowTabEdit: React.FC<WorkflowEditPageProps> = (
  props: WorkflowEditPageProps
) => {
  return (
    <StyledContainer>
      <WorkflowEditPage {...props} />
    </StyledContainer>
  );
};

export default WorkflowTabEdit;
